import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GivCustomerInitInfo } from '../../../../common-services/giv.service';

// import { LBSubscription } from './../../../../common-services/admin.service';
import { AppinfoService, USState } from './../../../../common-services/appinfo.service';
import { SubscriptionManagementService } from './../../../../common-services/subscription-management.service';
import { SubLevelSliderComponent, SubLevel, SliderChangeData } from './../sub-level-slider/sub-level-slider.component';

export interface SubscribeModalData {
	appName: string;
	givState?: string;
}

// interface PlanLevel {
// 	name: string;
// 	value: number;
// }

@Component({
	selector: 'app-modal-sub-subscribe',
	templateUrl: './modal-sub-subscribe.component.html',
	styleUrls: ['./modal-sub-subscribe.component.css']
})
export class ModalSubSubscribeComponent implements OnInit {

	// App name
	public appName: string;
	//
	public subLevel: SubLevel;
	// term values, month/year
	// public term;
	public termLevels: any[];
	// get today date to set minimum date input
	public today: string;
	// the subscribtion length, the number of month/year
	public quantity: number;
	// selected term, month/year
	public selectedTerm: string;
	public startDate;
	public endDate;

	// For azgiv
	public readonly azgivAppName = 'AZGIV';
	// public givState: USState;
	public states: USState[];
	givInfo: GivCustomerInitInfo = {
	}

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: SubscribeModalData,
		public dialogRef: MatDialogRef<ModalSubSubscribeComponent>,
		private appinfoService: AppinfoService,
		private subManagementService: SubscriptionManagementService
	) { }

	close(isApply: boolean) {
		if (isApply) {
			const data: any = {
				subLevel: this.subLevel,
				startDate: this.startDate,
				endDate: this.endDate,
				term: this.selectedTerm,
				givInfo: {}
			}
			if (this.appName === this.azgivAppName) {
				// data.givState = this.givState.code;
				data.givInfo = this.givInfo;
			}
			this.dialogRef.close(data);
		} else {
			this.dialogRef.close(false);
		}
	}
	updateSlider(e: SliderChangeData) {
		this.subLevel = e.level;
	}
	updateQuantity() {
		this.changeStartDate();
	}
	changeTermLevel() {
		this.changeStartDate();
	}
	public changeStartDate() {
		if (this.startDate && this.quantity && this.selectedTerm) {
			const date = new Date(this.startDate);
			const year = date.getFullYear();
			const month = date.getMonth();
			const day = date.getDate();
			// Calculate renewal date
			switch (this.selectedTerm) {
				case 'Year':
					this.endDate = new Date(year + this.quantity, month, day).toISOString().split('T')[0];
					break;
				case 'Month':
					this.endDate = new Date(year, month + this.quantity, day).toISOString().split('T')[0];
			}
		} else {
			this.endDate = null;
			return;
		}
	}
	initTermLevels() {
		this.termLevels = [
			{
				name: 'Month' // Updating of name should change changeStartDate()
				// value: 30 // TODO
			}, {
				name: 'Year'
				// value: 365 // TODO
			}
		];
	}

	async ngOnInit() {
		const subLevels = this.subManagementService.getSubscriptionLevels();
		this.subLevel = subLevels.find((l) => l.value === this.appinfoService.defaults.misc.subLevel) || subLevels[0];
		this.selectedTerm = 'Year';
		this.quantity = 1;
		this.appName = this.data.appName;
		this.initTermLevels();

		const date = new Date();
		const offset = date.getTimezoneOffset();
		const localDate = new Date(date.getTime() - (offset * 60000));
		this.today = localDate.toISOString().split('T')[0];

		if (this.appName === this.azgivAppName) {
			if (!this.appinfoService.usStates) {
				await this.appinfoService.getUsStates();
			}
			this.states = this.appinfoService.usStates || [];
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/components/portal/subscription-manage/modal-sub-subscribe/modal-sub-subscribe.component.ts